import {
  useQueryStates,
  parseAsArrayOf,
  parseAsInteger,
  parseAsStringLiteral,
} from 'nuqs'
import {
  JET_ALERT_DATE_FIELD_VALUES,
  JET_ALERT_SORT_BY_VALUES,
  JET_ALERT_SORT_DIR_VALUES,
  JET_ALERT_STATUS_VALUES,
  JET_ALERT_TYPE_VALUES,
} from 'pages/Jet/shared/constants/alertType'

export const useJetAlertsFiltersQueryState = () => {
  return useQueryStates(
    {
      alertTypes: parseAsArrayOf(parseAsStringLiteral(JET_ALERT_TYPE_VALUES)),
      status: parseAsStringLiteral(JET_ALERT_STATUS_VALUES).withDefault(
        'active'
      ),
      dateField: parseAsStringLiteral(JET_ALERT_DATE_FIELD_VALUES).withDefault(
        'created_at'
      ),
      daysAgo: parseAsInteger.withDefault(7),
      sortBy: parseAsStringLiteral(JET_ALERT_SORT_BY_VALUES).withDefault(
        'last_alerted_at'
      ),
      sortDir: parseAsStringLiteral(JET_ALERT_SORT_DIR_VALUES).withDefault(
        'desc'
      ),
    },
    {
      urlKeys: {
        alertTypes: 'alert-types',
        status: 'status',
        dateField: 'date-field',
        daysAgo: 'days-ago',
        sortBy: 'sort-by',
        sortDir: 'sort-dir',
      },
    }
  )
}
